<script>
export default {
    setup() {
        
    },
}
</script>
<template>
    <router-view />
</template>